<script lang="ts">
  import type { Snippet } from 'svelte';
  import TabbedCard from '../common/TabbedCard.svelte';
  import Loading from '../Loading.svelte';
  import type { Class } from '$lib/api/types';

  interface Props {
    children: Snippet;
    classPromise: Promise<Class>;
    activePage: 'students' | 'classInfo';
    classId: string;
    hrefPrefix?: string;
  }

  let { children, classPromise, activePage, classId, hrefPrefix='' }: Props = $props();
</script>

<main class="container-fluid py-3" id="main-content">
  {#await classPromise}
    <Loading />
  {:then clazz}
    <h2 class="mb-3">{clazz.name}</h2>
    <TabbedCard
      tabs={[
        { title: 'Class Info', href: `${hrefPrefix}/classes/${classId}`, active: activePage === 'classInfo' },
        { title: 'Students', href: `${hrefPrefix}/classes/${classId}/students`, active: activePage === 'students' },
      ]}
    >
      {@render children?.()}
    </TabbedCard>
  {/await}
</main>
